import React from 'react';
import '../styles/components/MobileBlock.css';

function MobileBlock() {
  return (
    <div className="mobile-block">
      <div className="mobile-block__card">
        <a href="/" className="mobile-block__logo-link">
          <img src="/images/logo.svg" alt="셀프애드" className="mobile-block__logo" />
        </a>
        <div className="mobile-block__icon">💻</div>
        <h1 className="mobile-block__title">PC 환경에서 이용해주세요</h1>
        <p className="mobile-block__desc">
          현재 서비스는 PC 환경에 최적화되어 있습니다.<br />
          더 나은 경험을 위해 PC로 접속해주세요.
        </p>
      </div>
    </div>
  );
}

export default MobileBlock;
